
// @mui material components
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftAvatar from "components/SoftAvatar";
import SoftButton from "components/SoftButton";

// Wizard application components
import FormField from "layouts/applications/wizard/components/FormField";

// Images
import team2 from "assets/images/team-2.jpg";
import {useEffect, useState} from "react";
import SpaceShip from "../../../../../examples/Icons/SpaceShip";
import Cube from "../../../../../examples/Icons/Cube";
import Basket from "../../../../../examples/Icons/Basket";
import Office from "../../../../../examples/Icons/Office";
import Shop from "../../../../../examples/Icons/Shop";
// import Cube from "../../../../../examples/Icons/Cube";

function PipingEquipment({stepValidator, handleNext}) {
 const [piping, setPiping] = useState(false);
  const [equipment, setEquipment] = useState(false);
  const [buildFacility, setBuildFacility] = useState(false);
  useEffect((e)=>{
      stepValidator(false)
    if (localStorage.getItem("pe") === "piping"){
      handleSetPiping();
    }else if(localStorage.getItem("pe") === "equipment"){
      handleSetEquipment();
    }
  }, [setPiping, setEquipment])
  const handleSetPiping = (e) => {
    setPiping(true)
    setEquipment(false)
    setBuildFacility(false)
    localStorage.setItem("pe", "piping");
    localStorage.setItem("of2_items", JSON.stringify({"keys":["Corrosion"]})) // , "Mechanical Fatigue"
    localStorage.setItem("next_step", "of2")

    stepValidator(true);
    if (e !== null && e !== undefined && e.target !== null && e.target !== undefined){
      handleNext()
    }
  };
  const handleSetEquipment = (e) =>  {
    setEquipment(true)
    setPiping(false)
    setBuildFacility(false)
    localStorage.setItem("pe", "equipment");
    localStorage.setItem("next_step", "of1")
      stepValidator(true)
    if (e !== null && e !== undefined && e.target !== null && e.target !== undefined){
      handleNext()
    }
  };
  const handleSetBuildFacility = (e) =>  {
    setEquipment(false)
    setPiping(false)
    setBuildFacility(true)
    localStorage.setItem("pe", "build_your_facility");
    localStorage.setItem("next_step", "ft")
    stepValidator(true);
    if (e !== null && e !== undefined && e.target !== null && e.target !== undefined){
      handleNext()
    }
  };

   const customButtonStyles = ({
    functions: { pxToRem, rgba },
    borders: { borderWidth },
    palette: { transparent, dark, secondary },
  }) => ({
    width: pxToRem(150),
    height: pxToRem(120),
    borderWidth: borderWidth[2],
    mb: 1,
    ml: 0.5,
    color:"",

    "&.MuiButton-contained, &.MuiButton-contained:hover": {
      boxShadow: "none",
      border: `${borderWidth[2]} solid ${transparent.main}`,
      backgroundColor: `#69af35 !important`,
    },
    "&:hover": {
      backgroundColor: `#69af35 !important`,
      border: `${borderWidth[2]} solid ${secondary.main} !important`,

      "& svg g": {
        fill: rgba(dark.main, 0.75),
      },
    },
  });


  return (
    <SoftBox>
      <SoftBox width="80%" textAlign="center" mx="auto" mb={4}>
        <SoftBox mb={1}>
          {/*<SoftTypography variant="h5" fontWeight="regular">*/}
          {/*  Q2.*/}
          {/*</SoftTypography>*/}
        </SoftBox>
        <SoftTypography variant="body2" fontWeight="regular" color="text">
          What kind of facility do you want to assess ?
        </SoftTypography>
      </SoftBox>
      <SoftBox mt={2}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} sm={3}>
            <SoftBox textAlign="center">
              <SoftButton
                color="secondary"
                variant={piping ? "contained" : "outlined"}
                onClick={handleSetPiping}
                sx={customButtonStyles}
              >
                <Office size="24px" color={piping ? "white" : "dark"} />
              </SoftButton>
              <SoftTypography variant="h6">Piping</SoftTypography>
            </SoftBox>
          </Grid>
          <Grid item xs={12} sm={3}>
            <SoftBox textAlign="center">
              <SoftButton
                color="secondary"
                variant={equipment ? "contained" : "outlined"}
                onClick={handleSetEquipment}
                sx={customButtonStyles}
              >
                <Basket size="24px" color={equipment ? "white" : "dark"} />
              </SoftButton>
              <SoftTypography variant="h6">Equipment</SoftTypography>
            </SoftBox>
          </Grid>
          <Grid item xs={12} sm={3}>
            <SoftBox textAlign="center">
              <SoftButton color="secondary" variant={buildFacility ? "contained" : "outlined"}
                          onClick={handleSetBuildFacility} sx={customButtonStyles}>
                <Cube size="24px" color={buildFacility ? "white" : "dark"} />
              </SoftButton>
              <SoftTypography variant="h6">Build Your Facility</SoftTypography>
            </SoftBox>
          </Grid>
        </Grid>
      </SoftBox>
    </SoftBox>
  );
}

export default PipingEquipment;
